module.exports = __webpack_public_path__ + "img/6.1.bbb25198.jpg";